<template>
  <div>
    <label class="vv-radio" :class="{ 'vv-radio-selected': checked }">
      <gradient-check v-if="checked" class="check-mark" />
      <span v-else class="red-circle check-mark"></span>
      <span class="label">{{ label }}</span>
      <input
        type="radio"
        :name="name"
        :value="value"
        :id="value"
        :checked="checked"
        @change="onChange"
      />
    </label>
  </div>
</template>

<script>
import GradientCheck from '@/components/layout/svg/GradientCheck'

export default {
  name: 'VvRadio',
  components: { GradientCheck },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    name: String,
    value: String | Number,
    label: String,
    modelValue: String | Number
  },
  computed: {
    checked() {
      return this.modelValue === this.value
    }
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.vv-radio {
  display: block;
  text-align: left;
  padding: 25px 10px;
  border-bottom: 2px solid rgba(209, 209, 209, 0.28);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
  font-family: 'Avenir-Roman';

  & > * {
    vertical-align: middle;
  }

  .check-mark {
    margin-right: 20px;
  }

  /* Hide the browser's default radio button */
  & input {
    position: absolute;
    display: none;
  }

  /* Create a custom radio button */
  .red-circle {
    display: inline-block;
    height: 23px;
    width: 23px;
    border: 2px solid $primary;
    border-radius: 50%;
  }
}
</style>
